import { useOnPressEscapeSettings } from './useOnPressEscape.typed';
import { useEffect } from 'react';

export const useOnPressEscape = (props: useOnPressEscapeSettings) => {
  const { onEscape } = props;

  const handleKeyPress = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      onEscape();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
    // TODO: Clean up this effect's dependencies. We're disabling this lint error for now so we can
    // clean up the lint logs. Ideally we should rewrite this code to be less error prone and trust
    // the lint rule's judgement.
    // https://distilledsch.tpondemand.com/RestUI/Board.aspx#page=userstory/98606
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
